export var valuesUserTaskState = ["Open", "Done", "OverDue"];
/*

*/ 
//# sourceMappingURL=UserTaskState.js.map